var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"member-badge",class:{'hidden': _vm.shouldHide}},[(_vm.isLoading)?_c('a-spin',{attrs:{"size":"small"}}):_vm._e(),(!_vm.isLoading)?_c('presence-badge',{attrs:{"presence-id":_vm.presence.id,"owner-id":_vm.presence.ownerId,"name":_vm.presence.displayName}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }